import { CustomizeCharts, DUMMY_RANGE } from "../data/chart-configs";
import { revenueBreakdownChartInstanceData } from "./custom-converter/revenue-breakdown-chart";
import { chartTypeOverylaySorter } from "./shared";
import { ConverterInput } from "./types";

export const apiDataToInstanceData = (inputParams: ConverterInput) => {
  const { chartConfigDetails, chartId, timeFrame } = inputParams;

  if (chartId === CustomizeCharts.revenueBreakdownChart.id) {
    return revenueBreakdownChartInstanceData(inputParams);
  }

  return chartConfigDetails.chartDatas
    .slice()
    .sort(chartTypeOverylaySorter)
    .map((chartData) => {
      return {
        [DUMMY_RANGE]: {
          [timeFrame]: chartData.data,
        },
      };
    });
};
